import { queryParam } from 'apps/utility/queryParams'
import { getCookieByName } from 'js/bankrate-utilities'

/**
 * `brmp` is legacy version and should only be used as directed by data team
 *
 * @returns {string|*}
 */
export default function getPid() {
  if (queryParam('pid')) return queryParam('pid')

  const attributionCookie = JSON.parse(
    decodeURIComponent(getCookieByName('attr'))
  )
  if (attributionCookie) {
    return attributionCookie['brmp_pid']
  }

  return 'br3'
}

export function getAttrPid() {
  const attr = JSON.parse(decodeURIComponent(getCookieByName('attr')))
  if (attr && attr.attr_pid) {
    return attr.attr_pid
  }

  return null
}
